import Storage from './Storage'

const SETTINGS_FIELDS = {
    debug: {
        default: false
    },
    theme: {
        default: 'bootstrap-4',
        allowed: ['bootstrap-4', 'bootstrap-3']
    },
    timeZone: {
        default: undefined
    },
    language: {
        default: 'en',
        allowed: ['en', 'bg', 'de', 'ar', 'fr']
    },
    rowsPerPage: {
        default: 20
    },
    editModes: {
        default: ['create', 'update', 'add', 'edit', 'manage', 'store']
    },
    viewModes: {
        default: ['view', 'index', 'list', 'preview', 'show']
    }
}

class Settings extends Storage
{
    constructor(settings = {}) {
        if( settings === undefined ) {
            settings = {}
        }

        if( ! isObject(settings)) {
            throw new Error('[Settings::constructor()] Invalid settings are given. Please specify an object.')
        }

        super(settings)
    }

    setMultiple(data) {
        if( ! isObject(data) ) {
            data = {}
        }

        for( let key in SETTINGS_FIELDS ) {
            if( data[key] === undefined ) {
                data[key] = SETTINGS_FIELDS[key].default
            }
        }

        return super.setMultiple(data)
    }

    set(key, value) {
        if( ! inArray(key, Object.keys(SETTINGS_FIELDS)) ) {
            throw new Error(`[Settings::set()] Settings key: "${key}" is invalid. Key name can be one of the following: [${Object.keys(SETTINGS_FIELDS).join(', ')}]`)
        }

        if( SETTINGS_FIELDS[key].allowed !== undefined && ! inArray(value, SETTINGS_FIELDS[key].allowed) ) {
            throw new Error(`[Settings::set()] You are trying to set an invalid value: "${value}" for key: "${key}". Allowed: [${SETTINGS_FIELDS[key].allowed.join(', ')}]`)
        }

        super.set(key, value)
    }

    get(key, otherwise = undefined) {
        if( ! inArray(key, Object.keys(SETTINGS_FIELDS)) ) {
            throw new Error(`[Settings::get()] Settings key: "${key}" is invalid. Allowed keys are: [${Object.keys(SETTINGS_FIELDS).join(', ')}]`)
        }

        return super.get(key, SETTINGS_FIELDS[key].default)
    }
}

export default new Settings()
